import {
  Divider,
  GKTextField,
  Grid2,
  SearchIcon,
  Show,
  SimpleLoader,
  Skeleton,
  Typography,
} from "components";
import { useDebounceCallback } from "hooks/useDebounceCallback";
import { useFetchQuery } from "hooks/useQueries";
import { ClientBasketInterface } from "interfaces/ClientBasket";
import DashboardLayout from "layouts/DashboardLayout";
import { filter, includes, toLower } from "lodash";
import { useState, useTransition } from "react";
import useDocumentTitle from "utils/useDocumentTitle";
import ClientEquityBasketCard from "./ClientEquityBasketCard";

const ClientBasket = () => {
  useDocumentTitle("Basket");

  const [isPending, startTransition] = useTransition();
  const [searchText, setSearchText] = useState("");

  const { data, isFetching } = useFetchQuery({
    key: ["FETCH_CLIENT_BASKETS"],
    route: "/client/basket/",
  });

  const debouncedHandleChange = useDebounceCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      startTransition(() => {
        setSearchText(e.target.value);
      });
    },
  );

  return (
    <DashboardLayout title="Basket">
      <Grid2 container spacing={1}>
        <Grid2
          container
          size={12}
          spacing={1}
          display={"flex"}
          alignItems={"center"}
        >
          <Grid2>
            <GKTextField
              fullWidth={false}
              placeholder="Search..."
              size="small"
              type="search"
              style={{ width: 300 }}
              onChange={debouncedHandleChange}
              aria-placeholder="Search basket name"
              slotProps={{
                input: {
                  startAdornment: (
                    <SearchIcon
                      width={22}
                      height={22}
                      color={"var(--neutral-500)"}
                    />
                  ),
                },
              }}
            />
          </Grid2>
          {/* <Grid2>
            <IconButton>
              <IoFilterOutline size={16} />
            </IconButton>
          </Grid2> */}
          <Grid2>
            <Divider orientation="vertical" sx={{ height: "24px", mx: 1 }} />
          </Grid2>
          <Grid2>
            <Typography
              fontSize={12}
              fontWeight={500}
              color={"var(--neutral-500)"}
              display={"flex"}
              alignItems={"center"}
              gap={0.5}
            >
              Total Baskets:
              <Typography fontWeight={600} color={"var(--neutral-500)"}>
                {isFetching || isPending ? (
                  <Skeleton variant="rectangular" width={30} height={15} />
                ) : (
                  data?.data?.data?.filter((dataItems: ClientBasketInterface) =>
                    dataItems?.basketName
                      ?.toLowerCase()
                      ?.includes(searchText?.toLowerCase()),
                  ).length || 0
                )}
              </Typography>
            </Typography>
          </Grid2>
        </Grid2>
        <Grid2 size={12}>
          <Divider />
        </Grid2>
        <Show.When
          isTrue={
            (!isFetching || !isPending) &&
            data?.data?.data?.filter((dataItems: ClientBasketInterface) =>
              dataItems?.basketName
                ?.toLowerCase()
                ?.includes(searchText?.toLowerCase()),
            ).length !== 0
          }
          showNodata
          textContent="Not data found!"
        >
          {isFetching || isPending ? (
            <Grid2 size={12}>
              <SimpleLoader />
            </Grid2>
          ) : (
            filter(data?.data?.data, (dataItems: ClientBasketInterface) => {
              return includes(
                toLower(dataItems?.basketName),
                toLower(searchText),
              );
            })?.map((basket: ClientBasketInterface) => {
              return (
                <Grid2 size={12} p={"32px 16px"} key={basket?.basketId}>
                  <ClientEquityBasketCard {...basket} />
                </Grid2>
              );
            })
          )}
        </Show.When>
      </Grid2>
    </DashboardLayout>
  );
};

export default ClientBasket;
